module.exports = __webpack_public_path__ + "img/dancing.02a40ff1.svg";